import { generateKeys, generateLocalization } from '../utils';
export const appendicesSubOptions = generateKeys({
    minDeposit: {
        value: 'minDeposit',
        label: 'Minimun Deposit',
    },
    percentage: {
        value: 'percentage',
        label: 'Revenue Share Percentage',
    },
    lots: {
        value: 'lots',
        label: 'Lots',
    },
    positionsCounts: {
        value: 'positionsCounts',
        label: 'Positions Counts',
    },
    volume: {
        value: 'volume',
        label: 'Volume',
    },
    cpaAmount: {
        value: 'cpaAmount',
        label: 'Cpa Amount',
    },
    fromDeposit: {
        value: 'fromDeposit',
        label: 'From deposit',
    },
    toDeposit: {
        value: 'toDeposit',
        label: 'To deposit',
    },
});
export const appendicesOptions = generateKeys({
    revShare1: {
        value: 'revShare1',
        label: 'revShare 1',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.percentage.key],
    },
    cpa1: {
        value: 'cpa1',
        label: 'Qualification Criteria',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.minDeposit.key, appendicesSubOptions.lots.key,
            appendicesSubOptions.positionsCounts.key, appendicesSubOptions.volume.key],
    },
    cpa2: {
        value: 'cpa2',
        label: 'cpa 2',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    cpa3: {
        value: 'cpa3',
        label: 'cpa 3',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    cpa4: {
        value: 'cpa4',
        label: 'cpa 4',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    cpa5: {
        value: 'cpa5',
        label: 'cpa 5',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    cpa6: {
        value: 'cpa6',
        label: 'cpa 6',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid1: {
        value: 'hybrid1',
        label: 'Qualification Criteria',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.minDeposit.key, appendicesSubOptions.lots.key,
            appendicesSubOptions.positionsCounts.key, appendicesSubOptions.volume.key],
    },
    hybrid2: {
        value: 'hybrid2',
        label: 'hybrid 2',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid3: {
        value: 'hybrid3',
        label: 'hybrid 3',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid4: {
        value: 'hybrid4',
        label: 'hybrid 4',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid5: {
        value: 'hybrid5',
        label: 'hybrid 5',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid6: {
        value: 'hybrid6',
        label: 'hybrid 6',
        appendixSubOptions: [appendicesSubOptions.cpaAmount.key, appendicesSubOptions.fromDeposit.key,
            appendicesSubOptions.toDeposit.key],
    },
    hybrid7: {
        value: 'hybrid7',
        label: 'hybrid 7',
        isRequired: true,
        appendixSubOptions: [appendicesSubOptions.percentage.key],
    },
});
export const partnersAppendices = generateLocalization('partnersAppendices', generateKeys({
    revShare: {
        value: 'revShare',
        label: 'Revenue Share',
        messageKey: 'revShareContent',
        appendixOptions: [appendicesOptions.revShare1.key],
        localization: { id: '', defaultMessage: '' },
    },
    cpa: {
        value: 'cpa',
        label: 'CPA',
        messageKey: 'cpaContent',
        appendixOptions: [appendicesOptions.cpa1.key, appendicesOptions.cpa2.key, appendicesOptions.cpa3.key,
            appendicesOptions.cpa4.key, appendicesOptions.cpa5.key, appendicesOptions.cpa6.key],
        localization: { id: '', defaultMessage: '' },
    },
    hybrid: {
        value: 'hybrid',
        label: 'Hybrid',
        messageKey: 'hybridContent',
        appendixOptions: [appendicesOptions.hybrid1.key, appendicesOptions.hybrid2.key, appendicesOptions.hybrid3.key,
            appendicesOptions.hybrid4.key, appendicesOptions.hybrid5.key, appendicesOptions.hybrid6.key, appendicesOptions.hybrid7.key],
        localization: { id: '', defaultMessage: '' },
    },
}));
